"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SelectCustom;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _styles = require("@sart/styles");
var _excluded = ["value", "options", "onOptionChange", "icon", "selectedColor"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getLabel(_ref) {
  var icon = _ref.icon,
    label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      alignItems: 'flex-start',
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      display: 'flex',
      fontSize: 18,
      marginRight: '0.5em'
    }
  }, icon), /*#__PURE__*/_react["default"].createElement("span", {
    style: _objectSpread({
      fontSize: 14,
      color: _styles.colors.white
    }, _styles.typography.demi)
  }, label));
}
function SelectCustom(props) {
  var value = props.value,
    options = props.options,
    onOptionChange = props.onOptionChange,
    icon = props.icon,
    selectedColor = props.selectedColor,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var customTheme = function customTheme(theme) {
    return _objectSpread(_objectSpread({}, theme), {}, {
      borderRadius: 4,
      colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
        primary: selectedColor ? selectedColor : _styles.colors.subtle,
        primary75: _styles.colors.focus,
        primary50: _styles.colors.trivial,
        primary25: _styles.colors.subtle
      })
    });
  };
  var optionValue = function () {
    try {
      var valueIndex = options.findIndex(function (o) {
        return o.value === value;
      });
      // const valueDisplay = valueIndex > -1 ? options[valueIndex].label : ''

      var option = options[valueIndex];
      // const optionIndex = itemIndex

      return option;
    } catch (error) {}
  }();
  function handleChange(option) {
    if (onOptionChange) {
      onOptionChange(option);
    }
  }
  var DropdownIndicator = function DropdownIndicator(props) {
    return _reactSelect.components.DropdownIndicator && /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], (0, _extends2["default"])({
    components: {
      DropdownIndicator: DropdownIndicator
    },
    isSearchable: false,
    theme: customTheme,
    value: optionValue,
    formatOptionLabel: getLabel,
    options: options,
    onChange: handleChange,
    menuPortalTarget: document.body
  }, rest));
}